export default __webpack_public_path__ + "static/media/Ufal_white.93ea40cd.png";